<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<ods-card>
  <ods-card-item>
    <ods-card-col
      [title]="zertifikat().name"
      [headingLevel]="3"
      [badges]="badges()"
      [subtitle]="validityText()"
      data-test-id="certificate-card-header"
    />
    <ods-card-col-right>
      <div class="flex flex-col items-stretch gap-2">
        @if (isRenewActionVisible()) {
          <ods-button
            text="Erneuern"
            icon="autorenew"
            variant="outline"
            size="full"
            dataTestId="certificate-card-renew-button"
            (clicked)="renewClicked.emit()"
          />
        }
        @if (isRevokeActionVisible()) {
          <ods-button
            text="Widerrufen"
            icon="undo"
            variant="outline"
            size="full"
            destructive
            dataTestId="certificate-card-revoke-button"
            (clicked)="revokeClicked.emit()"
          />
        }
      </div>
    </ods-card-col-right>
  </ods-card-item>

  <ods-collapsible-section
    label="Zertifikatsdetails"
    labelSize="small"
    contentPadding="none"
    [expanded]="!detailsCollapsed()"
    data-test-id="certificate-card-details"
  >
    <ods-card list variant="ghost">
      @if (zertifikat() | hasLink: zertifikatLinkRel.CERTIFICATE) {
        <ods-card-item>
          <ods-card-col title="Signiertes Zertifikat">
            <p class="font-mono text-sm" data-test-class="certificate-card-detail-value">
              {{ signedCertificateDownload.fileName }}
            </p>
          </ods-card-col>
          <ods-card-col-right>
            <ods-button
              icon="save"
              [iconConfig]="{ size: 'small' }"
              variant="outline"
              size="fit"
              [tooltip]="signedCertificateDownload.fileName + ' herunterladen'"
              tooltipAriaType="aria-label"
              dataTestId="certificate-card-download-signed"
              (clicked)="downloadClicked.emit(signedCertificateDownload)"
            />
          </ods-card-col-right>
        </ods-card-item>
      }
      @if (zertifikat() | hasLink: zertifikatLinkRel.CA_CERTIFICATE) {
        <ods-card-item>
          <ods-card-col title="CA-Zertifikat">
            <p class="font-mono text-sm" data-test-class="certificate-card-detail-value">
              {{ caCertificateDownload.fileName }}
            </p>
          </ods-card-col>
          <ods-card-col-right>
            <ods-button
              icon="save"
              [iconConfig]="{ size: 'small' }"
              variant="outline"
              size="fit"
              [tooltip]="caCertificateDownload.fileName + ' herunterladen'"
              tooltipAriaType="aria-label"
              dataTestId="certificate-card-download-ca"
              (clicked)="downloadClicked.emit(caCertificateDownload)"
            />
          </ods-card-col-right>
        </ods-card-item>
      }
      <ods-card-item>
        <ods-card-col title="Fingerprint">
          <p class="font-mono text-sm" data-test-class="certificate-card-detail-value">{{ zertifikat().fingerprint }}</p>
        </ods-card-col>
        <ods-card-col-right>
          <ods-copy-button
            [value]="zertifikat().fingerprint"
            copyTooltip="Fingerprint kopieren"
            dataTestId="certificate-card-copy-fingerprint"
          />
        </ods-card-col-right>
      </ods-card-item>
    </ods-card>
  </ods-collapsible-section>
</ods-card>
